export default __webpack_public_path__ + "static/O0074-352dc0efdd16e790bb2c0682bfe8f153.png";